module.exports = __webpack_public_path__ + "static/media/banner_slide_1.8e1f0926.jpg";